// removed by extract-text-webpack-plugin
module.exports = {"companyLogo":"_2QH_","fontContainer":"_1YHb","text":"v0iS","imageContainer":"_1DQG","fontImage":"_11Me","colorsImage":"_34iR"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CaseStudies/Learn2EsportCaseStudy/styles.scss
// module id = 549
// module chunks = 0